import React from 'react'
import ConnectedIcon from './ConnectedIcon'
import DisconnectLink from './DisconnectLink'
import style from './style.styl'

const Connected = ({ integrationId, handleDisconnect }) => (
  <div className="Connected">
    <div className={`flex ${style.IntegrationControl}`}>
      <ConnectedIcon/>
      Account Connected
    </div>
    <DisconnectLink
      serviceName={integrationId}
      handleDisconnect={handleDisconnect}/>
  </div>
)

export default Connected



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/Connected.js